<template>
  <div class="final-confirmation">
    <h2 class="h3 mb-2"><b>{{ $t('purchases.final_confirmation.are_you_sure') }}</b></h2>
    <p class="text-muted mb-4">{{ $t('purchases.final_confirmation.this_is_your_last_chance_here') }}</p>

    <div class="card">
      <div class="card-body">
        <div v-if="expiryOn" class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons final-confirmation__icon">event</span>
          <div>
            <p class="mb-0"><b>{{ expiryOn }}</b></p>
            <p class="text-muted mb-0">{{ $t('purchases.final_confirmation.pro_access_ends') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons final-confirmation__icon">file_download</span>
          <div>
            <p class="mb-0"><b>{{ $t('purchases.final_confirmation.hiiker_pro_no_longer_available') }}</b></p>
            <p class="text-muted mb-0">{{ $t('purchases.final_confirmation.maps_and_features_gone') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons final-confirmation__icon">save</span>
          <div>
            <p class="mb-0"><b>{{ $t('purchases.final_confirmation.your_stats_are_saved') }}</b></p>
            <p class="text-muted mb-0">{{ $t('purchases.final_confirmation.hikes_and_data_stay_on_your') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3">
          <span class="material-icons final-confirmation__icon">favorite_border</span>
          <div>
            <p class="mb-0"><b>{{ $t('purchases.final_confirmation.reactivate_anytime') }}</b></p>
            <p class="text-muted mb-0">{{ $t('purchases.final_confirmation.we_ll_be_here_when_you') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ expiryOn: string | null }>();
</script>

<style scoped lang="scss">
.final-confirmation {
  &__icon {
    color: var(--text-muted, #b2b2b2);
  }
}
</style>
